var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('data-list',{attrs:{"title":"Промокоды","custom-headers":_vm.customHeaders,"breadcrumbs":_vm.breadcrumbs,"custom-create-item-fields":_vm.fields,"custom-create-item-model":_vm.model,"create-item-actions":_vm.actions,"data-source":_vm.dataSource}})
}
var staticRenderFns = []

export { render, staticRenderFns }